import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { CanalMidiaSocialPipe } from './canal-midia-social.pipe';
import { CanalMidiaSocialIconPipe } from './canal-midia-social-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CanalMidiaSocialPipe,
        CanalMidiaSocialIconPipe
    ],
    exports: [
        CanalMidiaSocialPipe,
        CanalMidiaSocialIconPipe
    ],
    providers: [
        CanalMidiaSocialPipe,
        CanalMidiaSocialIconPipe
    ]
})
export class CanalMidiaSocialPipeModule { }
